/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedContactDealerButton_user$ref = any;
export type PdpSharedDescriptionAdditionalOptionsContent_user$ref = any;
export type PdpSharedDescriptionAdditionalOptionsContent_user = {
    readonly " $fragmentRefs": PdpSharedContactDealerButton_user$ref;
    readonly " $refType": PdpSharedDescriptionAdditionalOptionsContent_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptionsContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    }
  ]
};
(node as any).hash = '862745f2a8b59e551ecc6367246d0c64';
export default node;
